/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpRedirectMap } from './DxpRoutes.defs';

/**
 * DXP Console route redirects.
 * @export
 */
export const DXP_ROUTE_REDIRECTS: DxpRedirectMap = {
  [`/`]: `/organizations`,
  [`/organization/:tenant/administration/subscriptions`]: `/organization/:tenant/administration/subscription`,
  [`/organization/:tenant/administration/subscriptions/*`]: `/organization/:tenant/administration/subscription`,
  [`/organization/:tenant/cdp`]: `/organization/:tenant/cdp/segmentation`,
  [`/organization/:tenant/component-service`]: `/organization/:tenant/component-service/component-sets`,
  [`/organization/:tenant/datastore`]: `/organization/:tenant/data-services`,
  [`/organization/:tenant/events`]: `/organization/:tenant/cdp/events`,
  [`/organization/:tenant/funnelback-analytics`]: `/organization/:tenant/optimization`,
  [`/organization/:tenant/funnelback-search`]: `/organization/:tenant/search`,
  [`/organization/:tenant/insights`]: `/organization/:tenant/optimization`,
  [`/organization/:tenant/logs`]: `/organization/:tenant/monitoring/logs`,
  [`/organization/:tenant/matrix`]: `/organization/:tenant/content-management`,
  [`/organization/:tenant/optimization/experiments/*`]: `/organization/:tenant/optimization/ab-tests`,
  [`/organization/:tenant/optimization/ujm`]: `/organization/:tenant/optimization/ujm/funnels`,
  [`/organization/:tenant/segmentation`]: `/organization/:tenant/cdp/segmentation`,
  [`/organization/:tenant/segmentation/config`]: `/organization/:tenant/cdp/segmentation/config`,
  [`/organization/:tenant/settings`]: `/organization/:tenant/administration/settings`,
  [`/organization/:tenant/settings/billing`]: `/organization/:tenant/administration/billing`,
  [`/organization/:tenant/settings/users`]: `/organization/:tenant/administration/users`,
  [`/organization/:tenant/subscriptions`]: `/organization/:tenant/administration/subscription`,
  [`/organization/:tenant/subscriptions/*`]: `/organization/:tenant/administration/subscription`,
};
